"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React, { forwardRef, useRef } from "react";
import { Label } from "../Label";
import { Stack } from "../Stack/Stack";
import { NumberInput } from "../NumberInput/NumberInput";
import { randomString } from "../../../utils";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { visuallyHidden } from "../../../styles/VisuallyHidden-css";
import { Text } from "../Text";
import { round } from "lodash";
import * as styles from "./Slider-css";
export const Slider = forwardRef(
  (_a, ref) => {
    var _b = _a, { label, value, onChange, min = 0, max = 100, step, unit, disabled, labelHidden, valueHidden } = _b, props = __objRest(_b, ["label", "value", "onChange", "min", "max", "step", "unit", "disabled", "labelHidden", "valueHidden"]);
    const id = useRef(randomString());
    const inputId = `slider-${id.current}`;
    const labelId = `slider-${id.current}-label`;
    const handleSliderChange = (event) => {
      onChange(event.target.valueAsNumber);
    };
    return /* @__PURE__ */ React.createElement(
      Stack,
      {
        relative: true,
        gap: labelHidden ? void 0 : "xxs",
        className: styles.container,
        style: assignInlineVars({ [styles.progress]: `${round((value - min) / (max - min), 2)}` })
      },
      /* @__PURE__ */ React.createElement(Stack, { direction: "horizontal", justify: labelHidden ? "end" : "spaceBetween", align: "center" }, /* @__PURE__ */ React.createElement(
        Label,
        {
          long: true,
          disabled,
          id: labelId,
          element: "label",
          htmlFor: inputId,
          className: labelHidden ? visuallyHidden : void 0
        },
        label
      ), !labelHidden && !valueHidden && /* @__PURE__ */ React.createElement(
        NumberInput,
        {
          labelHidden: true,
          hideStepper: true,
          autoGrow: true,
          snap: true,
          label,
          "aria-labelledby": labelId,
          value,
          min,
          max,
          step,
          onChange,
          variant: "underlined",
          size: "xs",
          formatValue: unit ? (value2) => `${value2}${unit}` : void 0,
          disabled
        }
      )),
      /* @__PURE__ */ React.createElement(
        "input",
        __spreadValues({
          className: styles.slider,
          id: inputId,
          ref,
          type: "range",
          value,
          onChange: handleSliderChange,
          min,
          max,
          step,
          disabled,
          "aria-labelledby": labelId,
          "aria-valuenow": value,
          "aria-valuetext": unit ? `${value}${unit || ""}` : void 0,
          "aria-orientation": "horizontal"
        }, props)
      ),
      labelHidden && !valueHidden && /* @__PURE__ */ React.createElement("output", { className: styles.output, htmlFor: inputId }, /* @__PURE__ */ React.createElement(Text, { strong: true, size: "xs", lineHeight: "compact" }, value, unit))
    );
  }
);
Slider.displayName = "Slider";
